import React, { useState } from "react";
import { IconButton, Button, Modal, SxProps, Box } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { getDownloadURL, ref } from "firebase/storage";
import { storage } from "../../firebase/firebase";

const buttonSx: SxProps = {
  border: "2px solid #00cc5b",
  backgroundColor: "white",
  color: "black",
  borderRadius: "20px",
  padding: "5px",
  marginLeft: "10px",
  cursor: "pointer",
  "&:hover": {
    backgroundColor: "#f0f0f0",
  },
};

const pdfModalStyles: SxProps = {
  position: "absolute",
  top: "5%",
  right: "10%",
  width: "75%",
  height: "95%",
  border: "2px solid #000",
  backgroundColor: "white",
  boxShadow: 5,
  padding: "8px 16px 8px",
  overflowY: "scroll",
  "&:focus": {
    outline: "none",
  },
};

const closeButtonStyles: SxProps = {
  position: "fixed",
  right: "12%",
  "&:hover": {
    backgroundColor: "lightgray",
  },
};

const ManualButton: React.FC<{}> = () => {
  const [open, setOpen] = useState(false);
  const [imgFileList, setImgFileList] = useState<string[]>([]);
  const slideNum = 28;

  const handleOpen = async () => {
    try {
      const imgFileNames = Array.from({ length: slideNum }, (_, i) => `manual${i + 1}.webp`);
      const folderPath = "AffiliationGroup/manual/";

      const urls = await Promise.all(
        imgFileNames.map(async (fileName) => {
          const fullPath = `${folderPath}${fileName}`;
          const fileRef = ref(storage, fullPath);
          const url = await getDownloadURL(fileRef);
          return url;
        })
      );

      setImgFileList(urls);
      setOpen(true);
    } catch (error) {
      console.error("Error getting file URLs: ", error);
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Button onClick={handleOpen} sx={buttonSx}>
        PDFを開く
      </Button>
      <Modal open={open} onClose={handleClose} style={{ height: "95vh" }}>
        <Box sx={pdfModalStyles}>
          <IconButton
            sx={closeButtonStyles}
            onClick={() => {
              setOpen(false);
            }}
            size={"small"}
          >
            <CloseIcon />
          </IconButton>
          {imgFileList.length > 0 &&
            imgFileList.map((res, index) => (
              <div key={index}>
                <img alt="" src={res} width="100%" height="100%" />
              </div>
            ))}
        </Box>
      </Modal>
    </>
  );
};

export default ManualButton;
